import { Dictionary } from '../utils';

const replaceParams = (compiledMessage: string, [key, value]: [string, string]) =>
  compiledMessage.replace(new RegExp(`{${ key }}`, 'g'), value);

export function compileMessage(message: string, params: Dictionary<string>): string {
  return message && params
    ? Object.entries<string>(params).reduce(replaceParams, message)
    : message;
}
